export const tableManagement = {
  tableManagement: {
    addAndEdit: {
      steps: {
        step1: "Tablo Yapılandırması",
        step2: "Oyun Yapılandırması",
        step3: "Tablo Bayrakları ve Anahtarları",
      },
      title: "Tablo Ekle",
      titleEdit: "Tablo Düzenle",
      add_table: "Tablo Ekle",
      tenant: "Kiracı",
      tenant_placeholder: "Kiracı girin",
      tenant_required: "Lütfen bir kiracı girin",
      lobby_id: "Lobi ID",
      lobby_id_placeholder: "Lobi girin",
      lobby_id_required: "Lütfen bir lobi seçin",
      allowedTenants: "İzin Verilen Kiracılar",
      allowedTenants_placeholder: "İzin verilen kiracıları girin",
      allowedTenants_required: "Lütfen izin verilen kiracıları girin",
      name: "Ad",
      name_placeholder: "Ad girin",
      name_required: "Lütfen bir ad girin",
      skincode: "Skin Kodu",
      skincode_placeholder: "Skin kodu girin",
      skincode_required: "Lütfen bir skin kodu girin",
      category: "Kategori",
      category_placeholder: "Kategori seçin",
      category_required: "Lütfen bir kategori seçin",
      type: "Tür",
      type_placeholder: "Tür seçin",
      type_required: "Lütfen bir tür seçin",
      currency: "Para Birimi",
      currency_placeholder: "Para birimi girin",
      currency_required: "Lütfen bir para birimi girin",
      limitType: "Limit Türü",
      limitType_placeholder: "Limit türü seçin",
      limitType_required: "Lütfen bir limit türü seçin",
      totalSeats: "Toplam Koltuk",
      totalSeats_placeholder: "Toplam koltuk sayısını girin",
      totalSeats_required: "Lütfen toplam koltuk sayısını girin ",
      totalSeats_max_required: "Toplam koltuk sayısı mevcut {{maxSeats}} koltuktan fazla olmamalıdır",
      minPlayers: "Minimum Oyuncu",
      minPlayers_placeholder: "Minimum oyuncu sayısını girin",
      minPlayers_required: "Lütfen minimum oyuncu sayısını girin",
      currentAllocatedSeats: "Mevcut Ayrılmış Koltuklar",
      currentAllocatedSeats_placeholder: "Mevcut ayrılmış koltukları girin",
      currentAllocatedSeats_required: "Lütfen mevcut ayrılmış koltukları girin",
      minBuyIn: "Minimum Katılım",
      minBuyIn_placeholder: "Minimum katılım tutarını girin",
      minBuyIn_required: "Lütfen minimum katılım tutarını girin",
      maxBuyIn: "Maksimum Katılım",
      maxBuyIn_placeholder: "Maksimum katılım tutarını girin",
      maxBuyIn_required: "Lütfen maksimum katılım tutarını girin",
      blinds: "Blindlar",
      blinds_small: "Küçük Blind",
      blinds_big: "Büyük Blind",
      blinds_small_required: "Küçük blind girin",
      blinds_big_required: "Büyük blind girin",
      blind_placeholder: "Blindları girin",
      ante: "Ante",
      ante_placeholder: "Ante girin",
      timeLimitMs: "Zaman Limiti (ms)",
      timeLimitMs_placeholder: "Zaman limitini ms cinsinden girin",
      timeLimitMs_required: "Lütfen zaman limitini ms cinsinden girin",
      timeoutDefaultAction: "Zaman Aşımı Varsayılan Aksiyonu",
      timeoutDefaultAction_placeholder: "Varsayılan aksiyon seçin",
      timeoutDefaultAction_required: "Lütfen bir varsayılan aksiyon seçin",
      serviceFeePercent: "Hizmet Ücreti (%)",
      serviceFeePercent_placeholder: "Hizmet ücreti yüzdesini girin",
      serviceFeePercent_required: "Lütfen hizmet ücreti yüzdesini girin",
      autoRetable: "Otomatik Tablo",
      autoRetable_required: "Lütfen otomatik tablo seçin",
      isAutoCreateGame: "Otomatik Oyun Oluştur",
      isAutoCreateGame_required: "Lütfen otomatik oyun oluşturmayı seçin",
      highlighted: "Vurgulandı",
      gameInProgress: "Oyun Devam Ediyor",
      waitingPlayersCount: "Bekleyen Oyuncu Sayısı",
      waitingPlayersCount_placeholder: "Bekleyen oyuncu sayısını girin",
      canJoinWaitingList: "Bekleme Listesine Katılabilir",
      canLeaveWaitingList: "Bekleme Listesinden Çıkabilir",
      isPasswordProtected: "Şifre Koruması Var",
      submit_button: "Ekle",
      success: "Tablo Yönetimi başarıyla eklendi",
      error: "Tablo Yönetimi eklenirken hata oluştu",
    },
    columns: {
      name: "Ad",
      id: "Tablo ID",
      currency: "Para Birimi",
      totalSeats: "Toplam Koltuk",
      tenant: "Kiracı",
      buyInRange: "Katılım Aralığı",
      blinds: "Blindlar",
      type: "Oyun Türü",
      category: "Kategori",
      action: "Aksiyonlar",
      players: "Oyuncular",
      lobby: "Lobi",
    },
    moreInfoDrawer: {
      tabs: {
        tableDetails: "Tablo Detayları",
        tableRounds: "Tablo Turları",
        onlineTableView: "Çevrimiçi Tablo Görünümü",
      },
      detail: {
        tableInfo: "Tablo Bilgisi",
        name: "Tablo Adı",
        type: "Tablo Türü",
        currency: "Para Birimi",
        blinds: "Büyük Blind - Küçük Blind",
        bbsb: "BB - SB",
        buyInRange: "Katılım Aralığı",
        lobbyId: "Lobi ID",
        additionalDetails: "Ek Detaylar",
        updatedAt: "Güncellenme Tarihi",
        createdAt: "Oluşturulma Tarihi",
        createdBy: "Oluşturan",
        id: "Tablo ID",
        isAutoCreateGame: "Otomatik Oyun Oluşturuldu",
        highlighted: "Vurgulandı",
        version: "Versiyon",
        serviceFeePercent: "Hizmet Ücreti (%)",
        gameState: "Oyun Durumu",
        skinCode: "Skin Kodu",
        timeoutDefaultAction: "Zaman Aşımı Varsayılan Aksiyonu",
        dealerIndex: "Dağıtıcı İndeksi",
        dealerPosition: "Dağıtıcı Pozisyonu",
        inProgress: "Devam Ediyor",
        isBetHappened: "Bahis Gerçekleşti",
        isEnded: "Sona Erdi",
        smallBlindIndex: "Küçük Blind İndeksi",
        tipPot: "Bahşiş Potu",
        sidePot: "Yan Pot",
        waitingPlayersCount: "Bekleyen Oyuncu Sayısı",
        pot: "Pot",
        phase: "Aşama",
        lastAction: "Son Aksiyon",
        playerSeats: "Oyuncu Koltukları",
        totalSeats: "Toplam Koltuk",
        activePlayers: "Aktif Oyuncular",
      },
      onlineTableView: {
        onlineTableView: {
          onlineActionDetails: {
            title: "Çevrimiçi İşlem Detayları",
          },
          lobbyName: "Lobi Adı",
          lobbyId: "Lobi Numarası",
          tableName: "Masa Adı",
          tableId: "Masa Numarası",
          gameType: "Oyun Türü",
          currency: "Para Birimi",
          buyInRange: "Buy-in Aralığı",
          bbsb: "BB/SB",
          tableSeat: "Masa Koltuğu",
          roundInfo: "El Bilgisi",
          roundId: "El Numarası",
          roundStartingDate: "El Başlangıç Tarihi",
          bb: "Büyük Blind",
          sb: "Küçük Blind",
          dealer: "Dağıtıcı",
          roundStatus: "El Durumu",
          roundPot: "El Potu",
          roundWinner: "El Kazananı",
          noPlayer: "Oyuncu Yok",
          currentPot: "Mevcut Pot",
          lastAction: "Son İşlem",
          noAction: "İşlem Yok",
          currentPlayer: "Mevcut Oyuncu",
          nextPlayer: "Sıradaki Oyuncu",
          hasBetHappened: "Bahis Yapıldı mı?",
          betDescription: "Lorem ipsum dolor sit amet, consectetuer Ada adipiscing elit",
          dealerIndex: "Dağıtıcı",
          smallBlindIndex: "Küçük Blind",
          bigBlindIndex: "Büyük Blind",
          totalSeats: "Toplam Koltuk",
          activePlayers: "Aktif Oyuncular",
          lastGameEvent: "Last Game Event",
          lastActionEventWithAmount: "{{playerName}} oyuncusu {{action}} hamlesini yaptı ve {{amount}} miktarında para yatırdı.",
          lastActionEvent: "{{playerName}} oyuncusu {{action}} hamlesini yaptı.",
        },
      },
    },
  },
};
